import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {dataToolSchemas} from '../../utils/schemas';

const toolName = 'get-site-info' as const;

const argumentZod = z.object({
  siteId: dataToolSchemas.siteId
    .optional()
    .describe(
      'The site ID to get information for. If not provided, uses the current site context.'
    ),
});

export const getSiteInfoManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get site information',
  family: 'site',
  llmTool: {
    name: toolName,
    description:
      'Gets comprehensive information about a site. By default, returns details for the current site, but can also get information for a specific site by providing a siteId. Returns site details including basic metadata, custom domains, localization settings, and other site configuration.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteMeta', action: 'read'}],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type GetSiteInfoArgumentType = z.infer<typeof argumentZod>;
